module.exports = {
    "collectionLabel": `Suggerimenti`
};


//# sourceMappingURL=it-IT.main.js.map
